type ViewPageLinkInput = {
  slug?: string;
  url?: { destination?: string };
};

// مقصدِ دکمهٔ «مشاهده صفحه»: پزشک با slug؛ مرکز slug ندارد و با url خودش می‌رود (نه /dr/undefined).
export const viewPageLink = ({ slug, url }: ViewPageLinkInput): string | undefined => {
  if (slug) return `https://paziresh24.com/dr/${slug}`;
  const destination = url?.destination;
  if (!destination) return undefined;
  return destination.startsWith('/center/https') ? destination.slice(8, -1) : destination;
};
